
import { Check, Clock } from "lucide-react";

interface PaymentStatusBadgeProps {
  status: string;
}

export const PaymentStatusBadge = ({ status }: PaymentStatusBadgeProps) => {
  // Ensure status is one of our known types or default to 'pending'
  const normalizedStatus = status === 'paid' ? 'paid' : 'pending';
  
  return (
    <div className="flex items-center gap-2">
      <div 
        className={`p-2 rounded-full ${
          normalizedStatus === 'paid' 
            ? 'bg-secondary text-secondary-foreground' 
            : 'bg-accent text-accent-foreground'
        }`}
      >
        {normalizedStatus === 'paid' ? <Check className="w-4 h-4" /> : <Clock className="w-4 h-4" />}
      </div>
      <span className="capitalize">{status}</span>
    </div>
  );
};
